import axios from "axios";
import { bconf, TypeQuerySearch } from "../../app/index";
import { TypeT } from "./../../app/types/types";
import { getValidCategories } from "../../utils/filterUtils";

export const getProducts = async (
  currentPage: number,
  excludeCategories: string,
  querySearch: TypeQuerySearch,
  token: TypeT,
  sessionCollections: any[] = [],
  sessionCategories: any[] = []
) => {
  const url = token.ApiBaseURL;
  const user = token.ApiCRMUsername;

  // Filtra le categorie selezionate dall'utente contro quelle disponibili nella sessione
  const validCategories = getValidCategories(querySearch.categories, sessionCategories);
  const cat = validCategories.map((elem) => elem.key).join(",");

  // Filtra le collections API basandosi sul range di prezzi selezionato dall'utente
  const collections = getCollections(querySearch, sessionCollections);

  // Imposta il valore di sortby con default 'brand_crescente'
  const sortby = querySearch.sortby || 'brand_crescente';

  // Costruisce l'URL per l'API Collection con tutti i parametri di filtro
  const callUrl = `${url}Collection?sessiontoken=${encodeURIComponent(
    token.value
  )}&idcollection=${encodeURIComponent(
    collections  // Collections API filtrate per range di prezzi
  )}&username=${encodeURIComponent(user)}&offset=${bconf().totalProductPerPage
    }&page=${currentPage}&categories=${cat}&filter=${encodeURIComponent(
      querySearch.keyword
    )}&categories_to_exclude=${encodeURIComponent(excludeCategories)}&sortby=${encodeURIComponent(sortby)}`;

  try {
    const result = await axios({
      method: "get",
      url: callUrl,
    });

    return result;
  } catch (error: any) {
    throw error;
  }
};

const getCollections = (querySearch: TypeQuerySearch, sessionCollections: any[]): string => {
  const userMin = querySearch.rangeValue[0];
  const userMax = querySearch.rangeValue[1];

  // Filtra le collections: includi quelle con valore massimo >= al minimo dell'utente E <= al massimo dell'utente
  // Es: se utente vuole 50-120€, includiamo collections da 50€ a 120€ (50€, 75€, 90€, 100€)
  const collections = sessionCollections.filter((collection) => {
    return collection.amount >= userMin && collection.amount <= userMax;
  });
  console.log(collections.map((elem) => elem.idCollection).join(","));
  // Restituisce gli idCollection in formato CSV per l'API
  return collections.map((elem) => elem.idCollection).join(",");

};
